export enum DetailFocusKeys {
  ButtonGroup = "DETAIL:BUTTONS",
  PlayButton = "DETAIL:PLAY_BUTTON",
  InfoButton = "DETAIL:INFO_BUTTON",
  PreviewButton = "DETAIL:PREVIEW_BUTTON",
  FavoriteButton = "DETAIL:FAVORITE_BUTTON",
}
